import ms from 'ms';

import { useAppSelector } from '@/redux/hooks';
import { getTotalBidsPlaced, getUserCreationDate, isUserLoggedIn } from '@/redux/modules/account/user/user.selectors';
import { getTotalWonItemsCount } from '@/redux/modules/wonItemsCount/wonItemsCount.selectors';

const MAX_BIDS_ALLOWED = 1;

/**
 * Determines if Purchase Protection banner should be shown to the user
 *
 * Banner shows when ALL conditions are met:
 * - User account created within the last 30 days
 * - User has placed 1 or fewer bids
 * - User has not won any items
 */
export const useShouldShowPurchaseProtectionBanner = (): boolean => {
    const createdDate = useAppSelector(getUserCreationDate);
    const totalBidsCount = useAppSelector(getTotalBidsPlaced);
    const isLoggedIn = useAppSelector(isUserLoggedIn);
    const wonItemsCount = useAppSelector(getTotalWonItemsCount);

    const isNewUser = createdDate && Date.now() - new Date(createdDate).getTime() <= ms('30d');
    const hasNotWonItems = wonItemsCount === 0;

    return !isLoggedIn || isNewUser || totalBidsCount <= MAX_BIDS_ALLOWED || hasNotWonItems;
};
